// src/components/BlogBanner.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./BlogBanner.css";

const BlogBanner = () => {
  return (
    <section className="blog-banner">
      <Container>
        <Row className="align-items-center">
          <Col md={12} className="text-content">
            <h2 className="banner-title">Blog</h2>
            <p className="breadcrumb">
              Home <span> » </span> <span className="active">Blog</span>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BlogBanner;
